export const filterConfigPrescriprion = {
  location: {
    title: 'Локация',
    options: [],
    searchPlaceholder: 'Найти локацию',
  },
  direction: {
    title: 'Направление',
    options: [],
    hasSearch: false,
  },
  created: {
    title: 'Дата проведения проверки',
    hasSearch: false,
  },
  dataTable: {
    title: 'Срок исполнения по предписанию',
    hasSearch: false,
  },
  responsible: {
    title: 'Ответственный',
    searchPlaceholder: '',
    hasSearch: false,
  },
  statusPrescription: {
    title: 'Статус предписания',
    options: [],
    hasSearch: false,
  },
  status: {
    title: 'Статус действий',
    options: [],
    hasSearch: false,
  },
  dataOfPrescription: {
    title: 'Фактическая дата закрытия предписания',
    hasSearch: false,
  },
};

export const initialFilterPrescriprion = {
  location: { selected: [], selectedIds: [], search: '' },
  direction: { selected: [], selectedIds: [], search: '' },
  created: { startDate: '', endDate: '' },
  dataTable: { startDate: '', endDate: '' },
  responsible: { selected: [], selectedIds: [], search: '' },
  statusPrescription: { selected: ['В процессе', 'Просрочено'], selectedIds: [1, 3] },
  status: { selected: [], selectedIds: [] },
  dataOfPrescription: { startDate: '', endDate: '' },
};

export const initialFilterOpenPrescriprion = {
  location: false,
  direction: false,
  created: false,
  dataTable: false,
  responsible: false,
  statusPrescription: false,
  status: false,
  dataOfPrescription: false,
};
